import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Optional, Output, Self, ViewChild} from '@angular/core';
import {MatFormFieldControl} from '@angular/material/form-field';
import {TdoInputComponent} from '../tdo-input/tdo-input.component';
import {noop, Subject} from 'rxjs';
import {NgControl} from '@angular/forms';
import {TdoTimeModel} from './models/tdo-time.model';
import {formatDate} from '@angular/common';

@Component({
  selector: 'tdo-time-input',
  templateUrl: './tdo-time-input.component.html',
  styleUrls: ['./tdo-time-input.component.scss'],
  providers: [
    {provide: MatFormFieldControl, useExisting: TdoInputComponent},
  ]
})
export class TdoTimeInputComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() interval: number = 15;
  @Input() widthString: string = '200px';
  @Input() placeholder: string = '';
  @Input() placeholderPosition: string = 'inline'; // inline / above 
  @Input() isRequired: boolean = false;
  @Input() min: number;
  @Input() max: number;

  // Overrides
  @Input() autofilled: boolean;
  @Input() controlType: string;
  @Input() disabled: boolean;
  @Input() empty: boolean;
  @Input() errorState: boolean;
  @Input() focused: boolean;
  @Input() id: string;
  @Input() required: boolean;
  @Input() shouldLabelFloat: boolean;
  @Input() userAriaDescribedBy: string; 
  @Input() maxCharacters: number = 0;

  @Output() dateChanged: EventEmitter<Date> = new EventEmitter<Date>();

  isShowDropdown = false;
  stateChanges = new Subject<void>();
  maskTime = [/[0-9]/, /\d/, ':', /\d/, /\d/];
  times: TdoTimeModel[] = [];
  private _value: Date;
  innerValue: string;
  
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngAfterViewInit() {
    let z=this.innerValue.replace(':', '_').replace(' ' , '');
    let element = document.getElementById(z) ;
    if (element)
      element.scrollIntoView();
    
  }

  ngOnInit(): void {

    const splitsPerHour = 60 / this.interval;
    const numInserts = 24 * splitsPerHour;
    // get start time endtime for office: working hours
    let startTimeHour=6;
    let endTimeHour=18;
 

    let hour = 0;
    let m = 0;
    let minutes = 0  ;
    for (let i = 1; i <= numInserts; i++ ) {
      m += this.interval;
      if (m % 60 === 0) {
        m = 0;
        ++hour;
      }
      const mod = new TdoTimeModel();
      minutes = m;
      mod.date = new Date();
      mod.date = new Date(mod.date.setHours(hour, minutes));

      let annotation = 'am';

      let str = minutes.toString();
      if (minutes === 0) {
        str = '00';
      }

      if (hour >= 12 && hour !== 24) {
        annotation = 'pm';
      }

      let h = hour;
      if (h > 12) {
        h = h - 12;
      } else {
        if (hour === 0) {
          h = 12;
        }
      }

      mod.dateStr = h + ':' + str + ' ' + annotation;
      mod.name= 'T'+ h + '_' + str + annotation;
      if(hour >= startTimeHour && (hour <= endTimeHour ) )
      {
        this.times.push(mod);
      }
     
    }
  }

  ngOnDestroy() {
    this.stateChanges.complete();
  }

  get value(): Date {
    return this._value;
  }

  @Input()
  set value(v: Date) {
    if (v !== this._value) {
      this._value = new Date(v);
      let annotation = 'am';
      if (v) {
        if (v instanceof Date && !isNaN(v.valueOf())) {
          let hours = v.getHours().toString();

          if (v.getHours() > 12) {
            annotation = 'pm';
            hours =  (v.getHours()  - 12).toString();
          }
          else if ( v.getHours() === 12){
            annotation = 'pm';
            hours = '12';
          }

          let minutes = v.getMinutes().toString();
          if (v.getMinutes() < 10) {
            minutes = '0' + v.getMinutes().toString();
          }
          const str = hours + ':' + minutes + ' ' + annotation;
          this.innerValue = str;

        } else {
          if (v.getHours() >= 12) {
            annotation = 'pm';
          }
          this.innerValue = v.getHours() + ':' + v.getMinutes() + ' ' + annotation;
        }
      }
      this.onChangeCallback(v);
      this.stateChanges.next();
    }
  }

  writeValue(value: any) {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  onDateSelected(time: TdoTimeModel) {

    const selectedDate = new Date(  this._value.getFullYear(), this._value.getMonth(), this._value.getDate(), time.date.getHours(), time.date.getMinutes());

    const formattedDate = new Date(formatDate(selectedDate, 'yyyy-MM-ddTHH:mm', 'en-US'));
    
    this.dateChanged.emit(formattedDate);
    this.isShowDropdown = false;
    this.innerValue = time.dateStr;
  }
}
